import http from '@/api/HttpHelper'

const state = {
    reportTypes: ['r0901', 'cp303', 'cp309'],
    selectedReportType: undefined,
    path: '',
    content: [],
    loading: false
}

const getters = {
    reportTypes (state) {
        return state.reportTypes
    },
    selectedReportType (state) {
        return state.selectedReportType
    },
    path (state) {
        return state.path
    },
    content (state) {
        return state.content
    },
    loading (state) {
        return state.loading
    },
    pathEnd (state) {
        return state.path === undefined ? undefined : state.path.substr(0, state.path.indexOf('/'))
    }
}

const mutations = {
    setReportTypes (state, reportTypes) {
        state.reportTypes = reportTypes
    },
    setContent (state, content) {
        state.content = content
    },
    setPath (state, path) {
        state.path = path
    },
    setSelectedReportType (state, reportType) {
        state.selectedReportType = reportType
    },
    setLoading (state, isLoading) {
        state.loading = isLoading
    }

}

const actions = {
    async getContent ({ commit, state }) {
        commit('setLoading', true)

        const params = {
            report: state.selectedReportType,
            path: state.path || ''
        }

        if (state.selectedReportType !== undefined) {
            const result = await http.get('importresult', {params: params})
            commit('setContent', result.data)
        }

        commit('setLoading', false)
    },
    setPath ({commit, dispatch}, path) {
        commit('setPath', path)
        dispatch('getContent')
    },
    setSelectedReportType({commit, dispatch}, reportType) {
        commit('setSelectedReportType', reportType)
        dispatch('setPath', undefined)
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}